// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2DalA","label":"Labeled_label__1WC9d","divider":"Labeled_divider__1gKtr"};